// Иконки этапов жизненного цикла (Remix Icon), по кругу в «Сменить иконку».
export const stageIcons = [
  "ri-user-add-line",
  "ri-fire-line",
  "ri-hand-coin-line",
  "ri-vip-crown-line",
  "ri-snowflake-line",
  "ri-thumb-up-line",
  "ri-time-line",
  "ri-flag-line",
];
